import { createBrowserHistory } from 'history'
import { applyMiddleware, compose, createStore } from 'redux'
import { routerMiddleware } from 'connected-react-router';
import rootReducer from './reducers';
import api from './middleware/api';

export const history = createBrowserHistory();

//middleware api receives a url, successAction and errorAction to execute
//

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default function configureStore(preloadedState) {
  const store = createStore(
    rootReducer(history),
    preloadedState,
    composeEnhancers(
      applyMiddleware(api,
        routerMiddleware(history),
      ),
    ),
  )

  return store
}
